<template>
  <v-row v-if="formulario">
    <v-col cols="12">
        <v-card-title>
          <v-row v-if="permissao">
            <v-col cols="10">
              <v-file-input
                small-chips
                multiple
                label="Arquivos"
                v-model="files"                
              ></v-file-input>
            </v-col>
            <v-col cols="2">
              <v-btn @click="adicionarArquivos" :disabled="files.length == 0"  color="primary text-center" small>Adicionar arquivos</v-btn>
            </v-col>
          </v-row>
          <p v-else>Arquivos</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-list subheader v-if="formulario.arquivos">
                <v-subheader>Arquivos</v-subheader>
                <v-list-item link
                  v-for="item in formulario.arquivos"
                  :key="item.basename"
                  class="pl-0"
                >
                    <v-list-item-avatar class="ma-0">
                      <v-icon>{{ icons[item.extension.toLowerCase()] || icons['other'] }}</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content class="py-2">
                      <v-list-item-title>{{item.name}}</v-list-item-title>
                      <v-list-item-subtitle>{{ formatBytes(item.size) }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action-text>
                        <v-btn icon>
                          <v-icon @click.stop="downloadItem(item)" color="primary lighten-1">mdi-arrow-down-bold-circle-outline</v-icon>
                        </v-btn>
                        <v-btn v-if="permissao" icon @click="deleteItem(item)" style="display: inline-block !important;">
                            <v-icon color="error lighten-1">mdi-delete-outline</v-icon>
                        </v-btn>
                    </v-list-item-action-text>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
    </v-col>

  </v-row>

</template>

<script>
const fileIcons = {
    zip: "mdi-folder-zip-outline",
    rar: "mdi-folder-zip-outline",
    htm: "mdi-language-html5",
    html: "mdi-language-html5",
    js: "mdi-nodejs",
    json: "mdi-json",
    md: "mdi-markdown",
    pdf: "mdi-file-pdf",
    png: "mdi-file-image",
    jpg: "mdi-file-image",
    jpeg: "mdi-file-image",
    mp4: "mdi-filmstrip",
    mkv: "mdi-filmstrip",
    avi: "mdi-filmstrip",
    wmv: "mdi-filmstrip",
    mov: "mdi-filmstrip",
    txt: "mdi-file-document-outline",
    xls: "mdi-file-excel",
    other: "mdi-file-outline"
};

import { formatBytes } from "./util";
import { mapActions } from "vuex";

export default {
  components: {
  },
  props: {
    lancamento: {
      require: true
    },    
    formulario: {
      require: true
    },
    urlFormulario: {
      require: false
    },
    permissao: {
      require: false
    },
    icons: { type: Object, default: () => fileIcons },
  },
  computed: {
  },
  data () {
    return {
      editing: false,
      files: [],   
    }
  },

  methods: {
    formatBytes,

    ...mapActions("formulario", ["upload", "downloadArquivo", "deleteArquivo"]),

    deleteItem(item) {
      const payload = {
        "indicadorId": this.lancamento.indicador.id,
        "lancamentoId": this.lancamento.id,              
        'formularioId': this.formulario.id,
        'urlFormulario': this.urlFormulario,
        'arquivoId': item.id
      }
      this.deleteArquivo(payload)
    },

    adicionarArquivos() {
      const payload = {
        "indicadorId": this.lancamento.indicador.id,
        "lancamentoId": this.lancamento.id,              
        'formularioId': this.formulario.id,
        'urlFormulario': this.urlFormulario,
        'files': Object.values(this.files)
      };
      
      this.upload(payload).then(() => {
        this.files = [] 
      });

    },

    downloadItem(item) {
      const payload = {
        "indicadorId": this.lancamento.indicador.id,
        "lancamentoId": this.lancamento.id,
        'arquivoId': item.id
      }
      this.downloadArquivo(payload)
    },
  },
};
</script>

<style>
</style>